<app-eca-modal-host (cancelClicked)="cancelClicked()"
                    (helpClicked)="helpClicked()"
                    (saveClicked)="saveClicked()"
                    [editButtonIcon]="['far', 'edit']"
                    [heading]="heading"
                    [isEditing]="true"
                    [noButtonIcon]="['far', 'times']"
                    [yesButtonIcon]="['far', 'save']"
                    class="modal-eca modal-eca-success"
                    noButtonColour="transparent">
  <div class="container">
    <div *ngIf="showingHelp" class="row">
      <div class="col">
        <app-eca-help-alert (helpCloseClicked)="helpClicked()" [helpHtmlText]="helpMessage"></app-eca-help-alert>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <form #contactTypeDetails="ngForm">
          <fieldset>
            <div class="container-fluid">
              <div class="row">
                <div class="col">
                  <app-eca-input [(value)]="businessUnit.name" [controlId]="'ctrlBusinessUnitName'"
                                 [isReadOnly]="false"
                                 [isRequired]="true"
                                 [isValid]="!submitted || !!businessUnit?.name"
                                 label="Name"
                                 popoverText="Please enter a short name for the business unit to refer to it later"
                                 validationMessage="Please enter the name for the business unit">
                  </app-eca-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-eca-input [(value)]="businessUnit.description" [controlId]="'ctrlBusinessUnitDescription'"
                                       [isReadOnly]="false"
                                       [isRequired]="false"
                                       label="Description"
                                       popoverText="Enter the details of the business unit"
                                       validationMessage="Please enter the description for the business unit">
                  </app-eca-input>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
</app-eca-modal-host>
